import React from "react";
import Typography from "@mui/material/Typography";
import darkTheme from '../../../src/theme';

const infoContainer = {                            
    paddingLeft: darkTheme.spacing(2),
    paddinRight: darkTheme.spacing(2),
    bottom: darkTheme.spacing(17),     
    '& h5': {
        fontSize: 14,
        color: darkTheme.palette.primary.location,        
        fontWeight: 100,
    },
    '& h6': {
        fontSize: 12,
        fontWeight: 100,
        color: darkTheme.palette.primary.dates,
        textTransform: 'capitalize',
    },            
};

function Info() {    
  return (
    <Typography component="div" sx={infoContainer}>            
        <Typography component="h6">
            Important Event Info:
        </Typography>
        <Typography component="h5">
            All sales final. No refunds or exchanges. Right of admission
            reserved.{" "}
        </Typography> 
    </Typography>      
  );
}

export default Info;

